export enum AuthRouteEnum {
  Register = '/auth/register',
  ForgotPassword = '/auth/forgot-password',
  ResetPassword = '/auth/reset-password',
  TwoFactorAuthentication = '/auth/two-factor-authentication',
  EmailVerification = '/auth/email-verification',
  ChangePassword = '/profile/change-password'
}